<template>
  <v-app-bar
    v-if="!loading"
    app
    color="white"
    clipped-left
    style="z-index: 101; height: 64px"
    :key="update"
  >
    <v-app-bar-nav-icon v-if="showMenuButton" @click="setDrawer()" />
    <v-img
      class="hidden-xs-only mx-10 px-2"
      align="center"
      justify="center"
      :src="
        require(`@/assets/${this.$store.getters.getLogo.path}/logo-nav.png`)
      "
      max-height="100"
      max-width="110"
      lazy-src
    />
    <v-spacer></v-spacer>

    <v-toolbar-items
      class="hidden-sm-and-down"
      v-for="(menu, index) in menus"
      :key="index"
    >
      <v-btn
        v-if="
          menu.visible &&
          menu.title === 'Messages' &&
          menu.availableRoutes.length
        "
        :to="{ name: menu.availableRoutes[0].routeName }"
        :class="{
          'navigation-buttons--active':
            menu.requirements
              .map((item) => item.routeName)
              .includes($route.name) ||
            menu.children.map((item) => item.routeName).includes($route.name),
        }"
        text
        :disabled="menu.disabled"
        :data-cy="`topBar_${menu.id}`"
        >{{ menu.title }}
        <div style="margin-bottom: 2px; margin-left: 5px">
          ({{ getMe.menu_access.messages.badge }})
        </div>
      </v-btn>

      <v-btn
        v-if="
          menu.visible &&
          menu.title !== 'Messages' &&
          menu.availableRoutes.length
        "
        :to="{ name: menu.availableRoutes[0].routeName }"
        :class="{
          'navigation-buttons--active':
            menu.requirements
              .map((item) => item.routeName)
              .includes($route.name) ||
            menu.children.map((item) => item.routeName).includes($route.name),
        }"
        :data-cy="`topBar_${menu.id}`"
        text
        :disabled="menu.disabled"
      >
        <v-icon v-if="menu.icon.length && menu.routeName === 'notifications'">
          {{
            getShowNotificationBadge
              ? "mdi-bell-badge-outline"
              : "mdi-bell-outline"
          }}
        </v-icon>

        <v-icon v-if="menu.icon.length && menu.routeName !== 'notifications'">
          {{ menu.icon }}
        </v-icon>

        <span v-if="menu.title.length">{{ menu.title }}</span>
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="btn-text--collapsed" text>
            <!-- <v-icon class="ml-1">mdi-account</v-icon> -->
            {{ getMe.user.username }}
            <v-icon class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in subMenus"
            :key="index"
            link
            active-class="navigation-buttons--active"
            @click="routeSubmenu(item)"
          >
            <v-list-item-action>
              {{ item.title }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <v-toolbar-items class="hidden-md-and-up my-auto">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text>
            <span v-if="getCurrentRoute().title.length">{{
              getCurrentRoute().title
            }}</span>
            <v-icon v-if="getCurrentRoute().icon.length">{{
              getCurrentRoute().icon
            }}</v-icon>
            <v-icon class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <template v-for="(menu, index) in menus">
            <v-list-item-title :key="index">
              <v-btn
                v-if="menu.visible && menu.title === 'Messages'"
                :class="{
                  'navigation-buttons--active':
                    menu.requirements
                      .map((item) => item.routeName)
                      .includes($route.name) ||
                    menu.children
                      .map((item) => item.routeName)
                      .includes($route.name),
                }"
                :to="{ name: menu.availableRoutes[0].routeName }"
                text
                :disabled="menu.disabled"
                :data-cy="`topBar_${menu.id}`"
                >{{ menu.title }}
                <div
                  class="grey--text"
                  style="margin-bottom: 2px; margin-left: 5px"
                >
                  ({{ getMe.menu_access.messages.badge }})
                </div>
              </v-btn>

              <v-btn
                v-if="menu.visible && menu.title !== 'Messages'"
                :class="{
                  'navigation-buttons--active':
                    menu.requirements
                      .map((item) => item.routeName)
                      .includes($route.name) ||
                    menu.children
                      .map((item) => item.routeName)
                      .includes($route.name),
                }"
                :to="{ name: menu.availableRoutes[0].routeName }"
                text
                :disabled="menu.disabled"
                :data-cy="`topBar_${menu.id}`"
              >
                <v-icon
                  v-if="menu.icon.length && menu.routeName === 'notifications'"
                >
                  {{
                    getShowNotificationBadge
                      ? "mdi-bell-badge-outline"
                      : "mdi-bell-outline"
                  }}
                </v-icon>

                <v-icon
                  v-if="menu.icon.length && menu.routeName !== 'notifications'"
                >
                  {{ menu.icon }}
                </v-icon>

                <span v-if="menu.title.length">{{ menu.title }}</span></v-btn
              >
            </v-list-item-title>
          </template>
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="btn-text--collapsed" text>
            <v-icon class="ml-1">mdi-account</v-icon>
            <v-icon class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="font-weight-bold">{{
              getMe.user.username
            }}</v-list-item-title>
          </v-list-item>
          <template v-for="(item, index) in subMenus" link>
            <v-list-item-title :key="index" @click="routeSubmenu(item)">
              <v-btn class="btn-text--collapsed body-1" text>{{
                item.title
              }}</v-btn>
            </v-list-item-title>
          </template>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import restrictions from "../../utils/restrictions";
export default {
  data: () => ({
    subMenus: [],
    drawer: null,
    loading: true,
    update: 0,
    menus: [],
  }),
  created() {
    this.setMenus();
    this.setAvailableRoutes();
    this.setSubMenus();
    if (Object.keys(this.getMe).length === 0) {
      this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
        this.handleMenus(resp);
        this.handleSubMenus(resp);
      });
    } else {
      this.handleMenus(this.getMe);
      this.handleSubMenus(this.getMe);
    }
  },

  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLAPSED") {
        this.drawer = mutation.payload;
      }

      if (
        mutation.type === "USER_ME" ||
        mutation.type === "USER_CRM_LICENCE_STATUS_SUCCESS"
      ) {
        //NOTE: Just to be sure the mutation is executed
        setTimeout(() => {
          this.setMenus();
          this.setAvailableRoutes();
          this.setSubMenus();
          this.handleMenus(state.user.user);
          this.handleSubMenus(state.user.user);
        }, 0);
      }
    });
  },

  methods: {
    getRouteChildren(routeName) {
      try {
        const findBase = this.$router.options.routes.find((item) => {
          return item.name === "base";
        });

        if (typeof findBase === "undefined" || findBase.children.length === 0)
          return null;

        const findRoute = findBase.children.find((item) => {
          return item.name === routeName;
        });

        if (
          typeof findRoute === "undefined" ||
          typeof findRoute.children === "undefined" ||
          findRoute.children.length === 0
        )
          return [];

        return findRoute.children.map((item, index) => {
          return { routeName: item.name, id: index, name: item.name };
        });
      } catch (error) {
        return [];
      }
    },

    setSubMenus() {
      this.subMenus = [
        {
          title: this.$t("components.navigationBar.topBar.account"),
          routeName: "account",
          requirements: [{ name: "dealers", id: 1, routeName: "dealers" }],
          visible: true,
          children: this.getRouteChildren("account"),
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          // title: this.$t("components.navigationBar.topBar.settings"),
          title: this.$t("components.navigationBar.topBar.settings"),
          routeName: "settings",
          visible: true,
          children: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          title: this.$t("components.navigationBar.topBar.logout"),
          routeName: "logout",
          visible: true,
          children: [],
          disabled: false,
        },
      ];
    },

    setMenus() {
      this.menus = [
        {
          id: "newsfeed",
          title: this.$t("components.navigationBar.topBar.newsfeed"),
          icon: "",
          routeName: "newsfeed",
          requirements: [{ name: "newsfeed", id: 1, routeName: "newsfeed" }],
          visible: true,
          children: this.getRouteChildren("newsfeed"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "dashboards",
          title: this.$t("components.navigationBar.topBar.dashboards"),
          icon: "",
          routeName: "dashboards",
          requirements: [
            { name: "dashboards", id: 1, routeName: "dashboards" },
          ],
          visible: true,
          children: this.getRouteChildren("dashboards"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "data",
          title: this.$t("components.navigationBar.topBar.data"),
          icon: "",
          routeName: "data",
          requirements: [{ name: "data", id: 1, routeName: "data" }],
          visible: true,
          children: this.getRouteChildren("data"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "users",
          title: this.$t("components.navigationBar.topBar.users"),
          icon: "",
          routeName: "users",
          requirements: [
            { name: "groups", id: 1, routeName: "brands" },
            { name: "dealers", id: 2, routeName: "dealers" },
            { name: "service_providers", id: 3, routeName: "serviceProviders" },
          ],
          visible: true,
          children: this.getRouteChildren("users"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "messages",
          title: this.$t("components.navigationBar.topBar.messages"),
          icon: "",
          routeName: "messages",
          requirements: [
            { name: "messages", id: 1, routeName: "messages" },
            // HACK route messages-thread is not in menu_access from the server response. Should be here, to anotate top bar, when user visits the route
            { name: "messages-thread", id: 2, routeName: "messages-thread" },
          ],
          visible: true,
          children: this.getRouteChildren("messages"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "boats",
          title: this.$t("components.navigationBar.topBar.boats"),
          icon: "",
          routeName: "builder",
          requirements: [
            { name: "items", id: 4, routeName: "items" },
            { name: "documents", id: 3, routeName: "documents" },
            { name: "boats", id: 1, routeName: "boats" },
            { name: "models", id: 2, routeName: "models" },
          ],
          visible: true,
          children: this.getRouteChildren("builder"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "tasks",
          title: this.$t("components.navigationBar.topBar.tasks"),
          icon: "",
          routeName: "tasks",
          requirements: [
            { name: "tasks", id: 1, routeName: "tasks" },
            { name: "services", id: 2, routeName: "services" },
            // HACK route tasksTemplate is not in menu_access from the server response. Should be here, to anotate top bar, when user visits the route
            { name: "tasksTemplate", id: 3, routeName: "tasksTemplate" },
          ],
          visible: true,
          children: this.getRouteChildren("task"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
        {
          id: "notifications",
          title: "",
          icon: "mdi-bell-outline",
          routeName: "notifications",
          requirements: [
            { name: "notifications", id: 1, routeName: "notifications" },
          ],
          visible: true,
          children: this.getRouteChildren("notifications"),
          availableRoutes: [],
          disabled: this.getIsUIDisabledBasedOnLicenceStatus,
        },
      ];
    },

    setAvailableRoutes() {
      this.menus = this.menus.map((item) => {
        return { ...item, availableRoutes: this.handleRouting(item) };
      });
    },

    handleRouting(menu) {
      let requestedRouteSubroutes = Object.keys(this.getMe.menu_access).filter(
        (key) =>
          this.getMe.menu_access[key].visible &&
          menu.requirements.map((item) => item.name).includes(key)
      );

      if (
        typeof requestedRouteSubroutes === "undefined" ||
        !requestedRouteSubroutes.length
      ) {
        return [];
      }

      requestedRouteSubroutes = requestedRouteSubroutes
        .map((item) =>
          menu.requirements.find((element) => element.name === item)
        )
        .sort((a, b) => a.id - b.id);

      return requestedRouteSubroutes;
    },

    handleMenus(resp) {
      this.menus.forEach((menu) => {
        menu.visible = menu.requirements
          .map((item) => item.name)
          .some((isVisible) => {
            try {
              return resp.menu_access[isVisible].visible;
            } catch (error) {
              return false;
            }
          });
      });

      this.loading = false;
    },

    handleSubMenus(resp) {
      if (this.getIframeStatus) {
        this.subMenus = this.subMenus.filter(
          (item) => item.routeName !== "logout"
        );
      }
    },
    routeSubmenu(menu) {
      if (menu.routeName === "logout") {
        this.$store.dispatch(AUTH_LOGOUT);
        this.$router.push({ path: "/login" });
        return;
      }

      if (menu.routeName === "account" && this.getMe.dealerships.length !== 0) {
        this.$router.push({
          name: "partners",
          query: { my_account: "true" },
        });
        return;
      }

      if (menu.routeName === "account" && this.getMe.dealerships.length === 0) {
        this.$router.push({
          name: "legal",
          query: { my_account: "true" },
        });
        return;
      }

      //HACK: Settings do not have routeName, it is a dialog
      if (menu.routeName === "settings") {
        this.$emit("open-settings", true);
        return;
      }

      console.error("Insufficient route", JSON.stringify(menu));
    },
    setDrawer() {
      this.drawer = !this.drawer;
      this.$store.commit("COLLAPSED", this.drawer);
    },
    getCurrentRoute() {
      let menu = this.menus.find((el) => {
        return el.requirements
          .map((item) => item.name)
          .some((item) => item === this.$route.meta.visible);
      });

      if (typeof menu === "undefined") {
        return { title: "", icon: "" };
      } else {
        return menu;
      }
    },
  },

  computed: {
    showMenuButton() {
      return this.$route.name == "messages" || this.$route.name == "data"
        ? false
        : true;
    },
    ...mapGetters([
      "isAuthenticated",
      "getMe",
      "getIframeStatus",
      "getTheme",
      "getShowNotificationBadge",
      "getIsUIDisabledBasedOnLicenceStatus",
    ]),
  },
};
</script>

<style scoped>
.btn-text--collapsed {
  text-transform: none;
}
.btn--align {
  margin: auto;
  width: 50%;
}
.grey--text {
  color: rgba(0, 0, 0, 0.6);
}
.navigation-buttons--active {
  background-color: var(--navigation-bar-background-color) !important;
  color: var(--navigation-bar-color) !important;
}
</style>
